




















import { Component, Vue } from 'vue-property-decorator';
import GiganautVue from '@/components/Shared/GiganautVue'
import { ContactAnonModule } from '@/store/modules/contactAnon';

@Component({
  name: 'MarketingOptOut',
  components: {  }
})
export default class extends GiganautVue {
  get loading() {
    return ContactAnonModule.loading;
  }
}
